import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import {
  ReactElement,
  JSXElementConstructor,
  ReactNode,
  ReactPortal,
  useEffect
} from "react";
import {
  ButtonWrapper,
  NetPremiunText,
  PremiumHeading,
  PremiunCueText,
  PremiunText,
  PremiunValue,
  DashedDivider
} from "./styles";
import SectionDivider from "@components/SectionDivider";
import Footer from "@widgets/footer";
import Button from "@acko-tech/building-blocks.ui.button-old";
import PrimaryButton from "@widgets/PrimaryButton";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import { useOnload } from "@utils/useOnLoad";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

interface Props {
  premiumData: any;
  actions: any;
  ctaLabel: string;
  netPremium: string;
  gstText: string;
}

const PremiumBreakUp = (props: Props) => {
  const { premiumData, ctaLabel, actions, netPremium, gstText } = props || {};

  const { on_load } = actions || {};

  useOnload({ on_load });

  return (
    <Box width="100%">
      {premiumData?.map(
        (
          premium: {
            data: any;
            heading: string;
            headingValue: string;
            cueText: string;
          },
          index
        ) => {
          const { data, heading, headingValue = "", cueText = "" } = premium;
          console.log({ index, premium });

          const hasData = data?.length > 0;
          if (!hasData) {
            return null;
          }
          return (
            <>
              <PremiumHeading>{heading}</PremiumHeading>
              <PremiumHeading>{headingValue}</PremiumHeading>
              <PremiunCueText>{cueText}</PremiunCueText>
              {data?.map((dataPoint) => {
                return (
                  <>
                    <Flex
                      justifyContent="space-between"
                      margin="12px 0px 0px 0px"
                    >
                      <PremiunText isBoldText={dataPoint?.boldText}>
                        {dataPoint.key}
                      </PremiunText>
                      <PremiunValue
                        isDiscount={dataPoint.isDiscount}
                        isBoldText={dataPoint?.boldText}
                      >
                        {dataPoint.isDiscount ? "- " : ""}₹{dataPoint.value}
                      </PremiunValue>
                    </Flex>
                  </>
                );
              })}
              {index === 0 ? <DashedDivider /> : <SectionDivider />}
            </>
          );
        }
      )}
      <Flex justifyContent="space-between" margin="12px 0px 8px 0px">
        <NetPremiunText>Net premium</NetPremiunText>
        <NetPremiunText>₹{netPremium}</NetPremiunText>
      </Flex>
      <PremiunText>{gstText}</PremiunText>
      <ButtonWrapper>
        <PrimaryButton
          actions={actions}
          label={ctaLabel}
          isFullWidth
          labelStyles={{ fontSize: "16px", fontWeight: 600 }}
        />
      </ButtonWrapper>
    </Box>
  );
};

export default connect(mapStateToProps)(PremiumBreakUp);
